<!--文本内容-->
<template>
  <div >
    <!--头部-->
    <el-row>
      <el-col :span="4"><div class="grid_content1"></div></el-col>
      <el-col :span="16">
        <div class="grid_content1">
          <ul>
            <div @click="jump">
                       </div>
            <li>
              <p>中山大学地球环境与地球资源研究中心</p>
            </li>
            <li></li>
            <li>
              <el-input placeholder="请输入内容" v-model="input1">
                <el-button slot="append" icon="el-icon-search" @click="selectList"></el-button>
              </el-input>

            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid_content"></div></el-col>
    </el-row>
    <!--Tabs标签页-->
    <el-row style='margin: 0;padding: 0'>
      <el-col :span="24">
        <div>
          <template>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--网站首页-->
              <el-tab-pane label="网站首页" name="HomePage" >
                <keep-alive>
                  <component   v-if="isChildUpdate1" :is='components.child0' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="研究领域" name="researchField">
                <keep-alive>
                  <component v-if="isChildUpdate2" :is='components.child1' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="新资讯" name="newInformation">
                <keep-alive>
                  <component v-if="isChildUpdate3" :is='components.child2' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="头条推荐" name="headlineRecommendation">
                <keep-alive>
                  <component v-if="isChildUpdate4" :is='components.child3' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="EDP课程" name="edp">
                <keep-alive>
                  <component  v-if="isChildUpdate5" :is='components.child4' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="低碳生活" name="lowCarbonLife">
                <keep-alive>
                  <component v-if="isChildUpdate6" :is='components.child5' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="地球牧歌俱乐部" name="earthMuGe">
                <keep-alive>
                  <component v-if="isChildUpdate7" :is='components.child6' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="平台伙伴" name="platformPartners">
                <keep-alive>
                  <component v-if="isChildUpdate8" :is='components.child7' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane label="专家达人" name="expert">
                <keep-alive>
                  <component  v-if="isChildUpdate9" :is='components.child8' style='padding-bottom: 20px'></component>
                </keep-alive>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </el-col>
    </el-row>
    <el-row style='margin-top: 50px'>
      <el-col :span="7"><div class="grid-content"></div></el-col>
      <!--面包屑-->
      <el-col :span="10">
        <div class="grid-content">
          <el-input placeholder="请输入内容" v-model="input2">
            <el-button slot="append" icon="el-icon-search" @click="selectList"></el-button>
          </el-input>
        </div>
      </el-col>
      <el-col :span="7"><div class="grid-content"></div></el-col>

    </el-row>
    <el-row>
      <el-col :span="6"><div class="grid-content"></div></el-col>
      <el-col :span="12">
        <!-- tabs选项卡-->
        <div class="grid-content" style='background-color: #fff;min-height: 600px;height: 100%'>
          <h2 style='width: 100%;text-align: left;font-weight: bold; font-size: 16px;'>共{{this.total}}篇文章</h2>
          <div style='font-size: 16px;color: #404040;min-height: 550px'>
          <ul v-for="item1 in newsListData" :key="item1.stringId" @click="newsDetails(item1)">
            <li class='content'>
              <ul>
                <li class='icon'>
                  <i class="el-icon-document"></i>
                </li>
                <li class='title'>
                  <a>{{item1.title}}</a>
                </li>
                <li class='date'>
                  <span>{{item1.creteNewTime}}</span>
                </li>
              </ul>
            </li>
          </ul>
          <!--分页-->
          <el-pagination  class="pagination"
            v-show="total>0"
            :total="total"
            :current-page.sync="queryNewsParams.pageNum"
            :page-size.sync="queryNewsParams.pageSize"
            @current-change="getSelectNewsList"
          >
          </el-pagination>
          </div>
        </div>
      </el-col>
      <el-col :span="6"><div class="grid-content"></div></el-col>
    </el-row>

    <!--插入尾部-->
    <div class="m-box" >
      <keep-alive>
        <component  :is='components.tail'></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import index from './index.vue'
import footer from './footer.vue'
import HomePage from "@views/auth/HomePage.vue";
import researchField from "@views/auth/researchField.vue";
import newInformation from "@views/auth/newInformation.vue";
import headlineRecommendation from "@views/auth/headlineRecommendation.vue";
import edp from "@views/auth/edp.vue";
import lowCarbonLife from "@views/auth/lowCarbonLife.vue";
import earthMuGe from "@views/auth/earthMuGe.vue";
import platformPartners from "@views/auth/platformPartners.vue";
import expert from "@views/auth/expert.vue";
import { selectNewsList} from '@/api/auth'

export default {
  created() {
    this.$nextTick(function(){
      if (this.$route.query.title != null && this.$route.query.title > 0) {
        this.title = this.$route.query.title;
        this.getSelectNewsList(this.title)
      }
    })

  },
  data () {
    return {
      tableListData: [],
      newsListData: [],
      subtitle:'',
      // 总条数
      total: 0,
      queryNewsParams:{
        pageNum: 1,
        pageSize: 10,
        type:'3',
        title:''
      },
      fits: ['cover'],
      tabPosition: 'left',
      activeName: 'HomePage',
      id: null,
      title:'',
      input2:'',
      input1: '',
      isChildUpdate1: true,
      isChildUpdate2: false,
      isChildUpdate3: false,
      isChildUpdate4: false,
      isChildUpdate5: false,
      isChildUpdate6: false,
      isChildUpdate7: false,
      isChildUpdate8: false,
      isChildUpdate9: false,

      components: {

        tail: footer
      },
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    }
  },
  methods: {
    jump() {
      this.$router.push({
        path: '/index',
      })
    },
    select(){
      if(this.input1==''){
        alert('搜索关键词不能为空')
      }else{
        this.$router.push({
          path: '/selectContent',
          query: {
            title: this.input1,
          },
        })
      }
    },
    selectList(){
      if(this.input2==''){
        alert('搜索关键词不能为空')
      }else{
        this.title=this.input2;
        this.getSelectNewsList(this.title)

      }
    },
    details(raw) {
      this.$router.push({
        path: '/index',
        query: {
          id: raw,
        },
      })
    },
    newsDetails(raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
        },
      })
    },
    getSelectNewsList() {
      let that = this;
      this.queryNewsParams.title=this.title;
      selectNewsList(this.queryNewsParams).then(res => {
        that.total = res.data.total;
        that.newsListData=res.data.records;
      })
    },
    handleClick(tab, event) {
      if (tab.name === "HomePage") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = true;
        this.details(0);
      } else if (tab.name === "researchField") {
        this.isChildUpdate2 = true;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(1);
      } else if (tab.name === "newInformation") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = true;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(2);
      } else if (tab.name === "headlineRecommendation") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = true;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(3);
      } else if (tab.name === "edp") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = true;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(7);
      } else if (tab.name === "lowCarbonLife") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = true;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(4);
      } else if (tab.name === "earthMuGe") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = true;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(8);
      } else if (tab.name === "platformPartners") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = true;
        this.isChildUpdate9 = false;
        this.isChildUpdate1 = false;
        this.details(5);
      } else if (tab.name === "expert") {
        this.isChildUpdate2 = false;
        this.isChildUpdate3 = false;
        this.isChildUpdate4 = false;
        this.isChildUpdate5 = false;
        this.isChildUpdate6 = false;
        this.isChildUpdate7 = false;
        this.isChildUpdate8 = false;
        this.isChildUpdate9 = true;
        this.isChildUpdate1 = false;
        this.details(6);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #fff;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  height: 50px;
  //面包屑
  .crumbs{
    line-height:50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
  //文本内容
  h2{
    height: 50px;
    width: 100%;
    background-color: #fff;
    font-size: 16px;
    font-family: " 黑体";
    font-weight: bold;
    line-height: 50px;
    padding-left: 15px;
    color: #333;
  }
  .content{
    height: 50px;
    padding: 0 15px;
    background-color: #fff;
    //border-bottom: 1px dashed #999;
    line-height: 50px;
    .icon{
      width:3%;
      float: left;
    }
    .title{
      width:82%;
      float: left;
      font-size: 14px;
      a{
        width: 100%;
        display: block;
        color: #666;
        font-family: " 黑体";
        overflow: hidden;        /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow:ellipsis;  /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap;     /*文本不换行*/
      }
      a:hover{
        color:#409EFF ;
      }
    }
    .date{
      width:15%;
      float: right;
      text-align: right;
      color: #999;
    }
  }
  .paging{
    width: 100%;
    height: 80px;
    background-color: #fff;
    .pagination{
      float: right;
      margin-top: 20px;
    }
  }
}
.grid_content1 {
  border-radius: 4px;
  min-height: 36px;
  height: 150px;
  ul{
    list-style-type: none;
    li{
      width:33.33%;
      height:60px;
      margin-top: 45px;
      display: block;
      float: left;
      img{
        width: 32%;
        min-width:80px;
        float: left;
      }
      h1{
        width: 68%;
        float: left;
        font-size:2.2rem;
        font-weight: bold;
        font-style: normal;
        color: #444;
        padding-left: 1rem;
        line-height: 60px;
      }
      p{
        font-size:1.2rem;
        font-family:“黑体”;
        margin-left: .8rem;
        font-weight: bold;
        line-height: 50px;
      }
    }
  }
}
//Tabs标签页
::v-deep .el-tabs__nav-scroll{
  width:100%;
  display: block;
  background-color: #6aa84f;
  .el-tabs__nav{
    width: 100%;
    text-align: center;
    margin: 0 auto;
    z-index: 0;
  }
  .el-tabs__item{
    font-family: Tahoma;
    font-size: 18px;
    color: #fff;
    border-right: 1px dashed #fff;
  }
  .el-tabs__item:nth-child(2){
    padding-left: 20px;
  }
  .el-tabs__item:nth-child(10){
    padding-right: 20px;
    border: 0;
  }
  .el-tabs__item:hover{
    background-color: #fff;
    color: #333;
  }
  .el-tabs__item:focus{
    background-color: #fff;
    color: #333;
  }
  //分页
  .pagination{
    margin-top: 15px;
    float: right;
  }
}
</style>
